import * as constants from './../constants';

export const getAllTeamLeads = (
    data: any,
    onSuccess?: Function,
    onError?: Function,
) => ({
    type: constants.API,
    payload: {
        url: '/cluster-managers/team-leads',
        method: 'POST',
        data,
        success: (resp: any) => {
            let data = resp?.response ?? {};
            return {
                type: constants.SET_CM_TEAM_LEADS,
                payload: data,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getTeamLeadFleets = (
    userId: string,
    data: any,
    onSuccess?: Function,
    onError?: Function,
) => ({
    type: constants.API,
    payload: {
        url: `/cluster-managers/${userId}/fleets`,
        method: 'POST',
        data,
        success: (resp: any) => {
            let data = resp?.response ?? {};
            return {
                type: constants.SET_TL_FLEETS,
                payload: data,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getRiderPassbook = (
    riderId: string,
    data: any,
    onSuccess?: Function,
    onError?: Function,
) => ({
    type: constants.API,
    payload: {
        url: `/tl/${riderId}/ev/wallet/details`,
        method: 'POST',
        data,
        success: (response: any) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getTLAttendance = (
    tlId: string,
    data: any,
    onSuccess?: Function,
    onError?: Function,
) => ({
    type: constants.API,
    payload: {
        url: `/cluster-managers/${tlId}/tl-attendance`,
        method: 'POST',
        data,
        success: (response: any) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const AddEditTeamLead = (
    data: any,
    onSuccess?: Function,
    onError?: Function,
) => ({
    type: constants.API,
    payload: {
        url: '/cluster-managers/team-leads/add',
        method: 'POST',
        data,
        success: (response: any) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});
